import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddEditDataAgent from './AddEditDataAgent';
import DataAgentExampleQueriesTab from './dataAgentPopUp/DataAgentExampleQueries/DataAgentExampleQueriesTab';

interface DataAgentTabsProps {
  entityType: string;
  dataAgentId?: string | null;
}

const DataAgentTabs: React.FC<DataAgentTabsProps> = ({ entityType, dataAgentId }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const showExampleTab = entityType === 'edit';

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="data agent form tabs" variant="fullWidth">
          <Tab label={entityType === 'edit' ? 'Edit Data Agent' : t('dataAgents.tabs.addDataAgent')} />
          {showExampleTab && <Tab label="Example" />}
        </Tabs>
      </Box>

      <Box>
        {activeTab === 0 && (
          <Box>
            <AddEditDataAgent />
          </Box>
        )}
        {activeTab === 1 && showExampleTab && (
          <Box sx={{ height: '100%' }}>
            <DataAgentExampleQueriesTab dataAgentId={dataAgentId || ''} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DataAgentTabs;
